import { createPortal } from 'react-dom';

/**
 * Portal Component
 * @param {{children: React.ReactNode}} props 
 * @returns 
 */
const Portal = ({ children }) => {
  if (typeof window === 'undefined') return null;
  return createPortal(children, document.body);
};

export default Portal;
